import React from "react";
import "../styles/home.css";
import Navbar from "../components/BlogNavbar";
import Partners from "../components/PartnersSection";

const Home = () => {
  return (
    <div className="home">
      <Navbar />
      <Partners />
    </div>
  );
};

export default Home;
